<template>
  <div>
    <v-list dense>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Type</v-list-item-title>
          <v-list-item-subtitle>{{ promoItem.type }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Free Quantity</v-list-item-title>
          <v-list-item-subtitle>{{ promoItem.quantity }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Stock ID</v-list-item-title>
          <v-list-item-subtitle>{{ promoItem.stockId }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'B1g1',
  props: {
    promoItem: {
      type: Object,
      required: true,
    },
  },
}
</script>